export const ORDERS_REQUEST = "ORDERS_REQUEST";
export const ORDERS_SUCCESS = "ORDERS_SUCCESS";
export const ORDERS_ERROR = "ORDERS_ERROR";

export const ORDERS_NEW_REQUEST = "ORDERS_NEW_REQUEST";
export const ORDERS_NEW_SUCCESS = "ORDERS_NEW_SUCCESS";
export const ORDERS_NEW_ERROR = "ORDERS_NEW_ERROR";

export const ORDER_STATUS_REQUEST = "ORDER_STATUS_REQUEST";
export const ORDER_STATUS_SUCCESS = "ORDER_STATUS_SUCCESS";
export const ORDER_STATUS_ERROR = "ORDER_STATUS_ERROR";